import { render, staticRenderFns } from "./UsersInfo.vue?vue&type=template&id=a15c29b2&scoped=true"
import script from "./UsersInfo.vue?vue&type=script&lang=js"
export * from "./UsersInfo.vue?vue&type=script&lang=js"
import style0 from "./UsersInfo.vue?vue&type=style&index=0&id=a15c29b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a15c29b2",
  null
  
)

export default component.exports